import { NCC_SUPPORT_EMAIL } from '@domain/constant/contact';

import classNames from 'classnames/bind';
import styles from './analysisError.module.scss';
const cx = classNames.bind(styles);

const AnalysisError = () => {
  return (
    <div className={cx('analyzeArea', 'error')}>
      <div className={cx('textArea')}>
        <p className={cx('text')}>결과 분석에 오류가 발생했어요.</p>
        <span className={cx('subText')}>
          <a href={NCC_SUPPORT_EMAIL} className={cx('mail')} target="_blank">
            {NCC_SUPPORT_EMAIL}
          </a>
          를 통해 문의해주세요.
        </span>
      </div>
    </div>
  );
};

export default AnalysisError;
